import React from "react";
import { Link } from "theme-ui";
import { Icon } from "../../../Icon";
import { InfoMessage } from "../../../InfoMessage";
import { NOT_BONDED_YET } from "../../lexicon";

export const Empty: React.FC = () => {
  return <InfoMessage title={NOT_BONDED_YET.term} icon={<Icon name="info-circle" />}>{NOT_BONDED_YET.description} Learn more: <Link href="https://www.chickenbonds.org/lusd-bonds" target="_blank">What is bLUSD? <Icon name="external-link-alt" /></Link></InfoMessage>;
};
